import { useCallback, useRef } from "react"

const useDebounce = <T extends (...args: any[]) => any>(callback: T, wait = 300) => {
  const timerId = useRef(0)

  const func = useCallback(
    (...args: Parameters<T>) => {
      clearTimeout(timerId.current)
      timerId.current = window.setTimeout(() => callback(...args), wait)
    },
    [callback, wait]
  )

  return func
}

export default useDebounce
